module.exports = __webpack_public_path__ + "static/media/EqualPerformance_02.cd1c181f.svg";